//#region imports
import React from 'react';
import propTypes from 'prop-types';
import { injectIntl, FormattedMessage } from 'react-intl';
import { numberWithCommas } from '../../../../utils/consts/index';
import { returnAirlineLogos } from '../../../../utils/utility';
import Checkbox from '../../../common/checkBox';
import '../../../common/dropDown/dropDown.scss';
import '../flightInformation/flightInformation.scss';
//#endregion
//#region  render
const FilterCard = (props) => {
  let {
    message,
    showJust,
    originName,
    destinationName,
    selectedList,
    indexFlight,
    CheckboxValue,
    checkBoxLabel,
    checkBoxId,
    list,
    type,
    selectedListName,
    checkName,
    icon,
    isLocalization,
    condition,
    hasCondition,
    availsFiled,
    availsList,
    languageName,
  } = props;
  const HAS_SELECTED_VALUE =
    selectedList.length > 0 &&
    selectedList[indexFlight] &&
    selectedList[indexFlight].length > 0;

  const SHOW_JUST =
    selectedList.length > 0 &&
    selectedList[indexFlight] &&
    selectedList[indexFlight].length > 1;
  let baggageMessage = '';
  return (
    <div className="card py-2 my-2 bg-primary border-top-0 border-right-0 border-left-0 border-bottom border-bottom-1 border-light rounded-0">
      <div
        className={`d-flex justify-content-between px-0 align-items-center font-weight-bold text-white bg-primary card-header border-0 font-small px-0 align-items-center ${
          languageName === 'fa' ? 'text-right' : 'text-left'
        }`}
      >
        <div className="d-flex flex-start align-items-center text-white">
          {icon}

          <span className={`font-small  text-captalize  px-2 text-nowrap`}>
            <FormattedMessage id={message} defaultMessage={message} />
          </span>
        </div>
        <div className="d-flex flex-grow-1 font-smaller align-items-center  text-nowrap">
          <span>{`${originName} - ${destinationName}`}</span>
        </div>
        {HAS_SELECTED_VALUE && (
          <div className="d-flex flex-end align-items-center">
            <span
              className="linkableDiv px-1  text-gold font-smaller  text-nowrap cursor-pointer"
              onClick={() => props.clearFilter(selectedListName, indexFlight)}
            >
              <FormattedMessage
                id="booking.clearfilter"
                defaultMessage="booking.clearfilter"
              />
            </span>
          </div>
        )}
      </div>
      {list && list.length > 0 && (
        <div className="card-body py-2 px-0">
          {list[indexFlight].map((item, index) => {
            if (type === 'baggage') {
              if (item.Type === 'ADT') {
                let unitName =
                  item.Unit.toLowerCase() === 'kg'
                    ? 'booking.kg'
                    : 'booking.pc';
                baggageMessage = `${
                  parseInt(item.Quantity) > 0
                    ? `${item.Quantity} ${props.intl.formatMessage({
                        id: unitName,
                        defaultMessage: unitName,
                      })}`
                    : props.intl.formatMessage({
                        id: 'booking.nobaggage',
                        defaultMessage: 'booking.nobaggage',
                      })
                }`;
              }
            }
            const LABEL_TEXT =
              type === 'provider'
                ? item[checkBoxLabel]
                : type === 'airport'
                ? `${item.name[languageName]} (${item.country.name[languageName]}) `
                : type === 'charter'
                ? item.isCharter
                  ? props.intl.formatMessage({
                      id: 'booking.charter',
                      defaultMessage: 'booking.charter',
                    })
                  : props.intl.formatMessage({
                      id: 'booking.systemic',
                      defaultMessage: 'booking.systemic',
                    })
                : type === 'baggage'
                ? baggageMessage
                : checkName
                ? item.name[languageName]
                : `booking.${item[checkBoxLabel]}`;

            const CONDITION =
              checkName && type !== 'airport'
                ? item.name[languageName]
                : type === 'airport'
                ? item[CheckboxValue]
                : item[CheckboxValue].toString();
            const VALUE =
              checkName && type !== 'airport' && type != 'provider'
                ? type === 'charter'
                  ? item[value]
                  : item.name[languageName]
                : item[CheckboxValue];

            return (
              (!hasCondition || (hasCondition && item[condition])) && (
                <div
                  key={`${type}-${indexFlight}-${index}`}
                  className="d-flex px-0 custom-control checkbox-filter custom-checkbox justify-content-between  font-small  text-truncate align-items-center py-1"
                >
                  <div
                    className={`d-flex flex-start outline-nones custom-control checkbox-filter py-1 custom-checkbox  px-0 justify-content-start  px-0 font-msmall `}
                  >
                    {/* render check box */}
                    <Checkbox
                      inputClassName={
                        availsList && availsList.length
                          ? availsList.filter((av_item) => {
                              return type !== 'airport'
                                ? av_item[availsFiled] === VALUE ||
                                    av_item[availsFiled].toString() === VALUE
                                : av_item[availsFiled] === VALUE;
                            }).length
                            ? 'text-white font-msmall'
                            : 'text-disabled'
                          : 'text-white'
                      }
                      isLocalization={isLocalization}
                      id={`${checkBoxId}-${indexFlight}-${index}`}
                      label={LABEL_TEXT}
                      checked={
                        HAS_SELECTED_VALUE &&
                        selectedList[indexFlight].indexOf(CONDITION) !== -1
                      }
                      value={VALUE}
                      parentInputClassName="font-msmall font-weight-bold p-0 m-0 "
                      onChange={(event) => {
                        // call filter functiom with keyword 'stopCountSelected' to push or pop form list of selectedFilter Object */
                        props.filterFlight(
                          event,
                          selectedListName,
                          indexFlight,
                        );
                      }}
                      tabIndex={index}
                    />
                    {/* show 'just link' for items that more than 1 selected item */}
                    {showJust &&
                      SHOW_JUST &&
                      selectedList[indexFlight].indexOf(CONDITION) !== -1 && (
                        <div
                          onClick={() =>
                            props.justFilter(
                              CONDITION,
                              indexFlight,
                              selectedListName,
                            )
                          }
                          className="px-1 text-gold align-items-center d-flex justify-content-end cursor-pointer text-underline font-xsmall font-weight-bold text-captalize"
                        >
                          <FormattedMessage
                            id="booking.justthis"
                            defaultMessage="booking.justthis"
                          />
                        </div>
                      )}
                  </div>

                  {type === 'airline' ? (
                    <div className="align-items-center justify-content-end d-flex p-0 ">
                      <span className="font-smaller font-weight-bold text-white px-2">
                        {/* {numberWithCommas((item.minPrice / 260000).toFixed(2))} */}
                        {numberWithCommas((item.minPrice / 10).toFixed(0))}
                      </span>
                      <img
                        className=" rounded-circle bg-white"
                        style={{ width: 24, height: 24 }}
                        src={returnAirlineLogos(item.code)}
                        alt="airline logo"
                      />
                    </div>
                  ) : type !== 'airport' && type !== 'provider' ? (
                    <div className="d-flex flex-end justify-content-end col-3 px-1 font-smaller text-white font-weight-bold align-items-center">
                      {/* {numberWithCommas((item.minPrice / 260000).toFixed(2))} */}
                      <span className="font-smaller font-weight-bold text-white px-2">
                        {numberWithCommas((item.minPrice / 10).toFixed(0))}
                      </span>
                      <img
                        className=" text-end rounded-circle bg-white"
                        style={{ width: 24, height: 24 }}
                        src={returnAirlineLogos(item.airlineCode)}
                        alt="airline logo"
                      />
                    </div>
                  ) : null}
                </div>
              )
            );
          })}
        </div>
      )}
    </div>
  );
};

//#endregion
//#region  default props and prop types
FilterCard.propTypes = {
  message: propTypes.string,
  showJust: propTypes.bool,
  originName: propTypes.string,
  destinationName: propTypes.string,
  selectedList: propTypes.array,
  indexFlight: propTypes.number,
  CheckboxValue: propTypes.string,
  checkBoxLabel: propTypes.string,
  checkBoxId: propTypes.string,
  list: propTypes.array,
  type: propTypes.string,
  selectedListName: propTypes.string,
  checkName: propTypes.bool,
  icon: propTypes.object,
  isLocalization: propTypes.bool,
  condition: propTypes.string,
  hasCondition: propTypes.bool,
  availsFiled: propTypes.string,
  availsList: propTypes.array,
  languageName: propTypes.string,
  filterFlight: propTypes.func,
  clearFilter: propTypes.func,
  justFilter: propTypes.func,
};
FilterCard.defaultProps = {
  message: '',
  showJust: false,
  originName: '',
  destinationName: '',
  selectedList: [],
  indexFlight: 0,
  CheckboxValue: '',
  checkBoxLabel: '',
  checkBoxId: '',
  list: [],
  type: '',
  selectedListName: '',
  checkName: false,
  icon: null,
  isLocalization: false,
  condition: '',
  hasCondition: false,
  availsFiled: '',
  availsList: [],
  languageName: '',
  filterFlight: () => {
    console.error("filter card component hasn't filterflight function");
  },
  clearFilter: () => {
    console.error("filter card component hasn't clearFilter function");
  },
  justFilter: () => {
    console.error("filter card component hasn't justFilter function");
  },
};
//#endregion
export default injectIntl(FilterCard);
